import { motion } from "framer-motion";
import React, { useContext, useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Tooltip } from "react-tooltip";

import AddFromSlideIcon from "../../../assets/icons/add-slide.svg";
import PlusSrc from "../../../assets/icons/add.svg";
import ClosePopupIcon from "../../../assets/icons/close-new.svg";

import { Notify } from "../../../components";
import Viewer from "../../../pages/slideSplitViewer/viewer-container";
import axios from "../../../utils/axiosInstance";
import { SocketContext } from "../../../utils/serviceContext";

import { addTumorBoardEnable } from "../../slidebox/actions/slidebox-action";
import SlideboxPage from "../../slidebox/SlideBox";
import { setSelectedBoard, setSlideUrl } from "../actions/groups-action";

const styles = {
  disabledButton: {
    color: "#999",
    cursor: "not-allowed",
    border: "1px solid #0b569f",
    marginTop: "40%",
  },
};

const ImagePanel = ({
  openSlidebox,
  setOpenSlidebox,
  imageFromSlideBox,
  group,
  onGroupRefresh,
  setSlideUrl,
  setSelectedBoard,
  addTumorBoardEnable,
  selectedListSlideData,
  groups,
}) => {
  const navigate = useNavigate();

  const [slideBoxId, setSlideBoxId] = useState(null);
  const [isModal, setIsModal] = useState(true);
  const [isFolderSelected, setIsFolderSelected] = useState(true);

  const socket = useContext(SocketContext);

  const handleOnNext = () => {
    const selectedBoard = groups.selectedBoard;

    selectedBoard.slide = [
      {
        dzi_data: `${selectedListSlideData.dzi_url.split(".dzi_files/")[0]
          }.dzi.dzi`,
        dzi_url: selectedListSlideData.dzi_url,
      },
    ];

    selectedBoard.slideId = selectedListSlideData.slidebox_slide_id;

    setTumorBoardSlide(selectedBoard);
  };

  const setTumorBoardSlide = async (folderPath) => {
    const body = {
      tumorBoardId: folderPath.id,
      slide: JSON.stringify(folderPath.slide[0]),
      slideId: folderPath.slideId,
    };

    Notify({ value: "Adding slide to group" });

    const result = await axios
      .put("/api/groups/slidePath", body)
      .catch((err) => {
        Notify({ value: err.response?.data?.message });
        return false;
      });

    if (
      result &&
      typeof result.status !== "undefined" &&
      result.status === 200
    ) {
      setOpenSlidebox(false);

      setSlideUrl(
        {
          slide: JSON.stringify(folderPath.slide[0]),
          slideId: folderPath.slideId,
        },
        true
      );

      folderPath.current = folderPath.slide.length - 1;

      setSelectedBoard(folderPath);

      await axios.post("/api/slidebox/getFileData", {
        keyFolder: selectedListSlideData.keyFolder,
      });

      Notify({ value: "Slide added successfully!!" });

      onGroupRefresh();

      addTumorBoardEnable(false);
    } else {
      setOpenSlidebox(false);
    }
  };

  const toggleModal = (e) => {
    const overlay = document.getElementById("quorum-modal-overlay");

    if (
      e === "CLOSE MODAL" ||
      e?.target === overlay ||
      e?.target?.classList?.contains("slidebox-next-page-btn") ||
      e?.target?.id === "close_modal_streams"
    ) {
      setOpenSlidebox(false);
    } else {
      setOpenSlidebox(true);
    }
  };

  useEffect(() => {
    if (!openSlidebox) {
      setIsFolderSelected(true);
    }
  }, [openSlidebox]);

  useEffect(() => {
    const subscription = socket.onUpdateBoard().subscribe((id) => {
      if (group.id === parseInt(id)) {
        onGroupRefresh();
      }
    });

    return () => {
      if (subscription) {
        subscription.unsubscribe();
      }
    };
  }, []);

  useEffect(() => {
    let currentSlideBoxId;

    if (Object.keys(imageFromSlideBox).length > 0) {
      currentSlideBoxId = imageFromSlideBox.fileid;
    } else {
      currentSlideBoxId = group.tumorBoardSlideId;
    }

    setSlideBoxId(currentSlideBoxId);
  }, [imageFromSlideBox, group]);

  const changeThumbnailSlide = (newSlideId) => {
    setSlideBoxId(newSlideId);
  };

  return (
    <div className="image-panel">
      <div className="content">
        <div className="quorum-action-main-container">
          {group &&
            slideBoxId !== undefined &&
            (Object.keys(imageFromSlideBox).length > 0 || group.slide) ? (
            <div className="group-viewer-container">
              {slideBoxId && (
                <Viewer
                  when="groups"
                  slideBoxId={slideBoxId}
                  groupId={group.id}
                  groupAdmin={group.admin}
                  changeThumbnailSlide={changeThumbnailSlide}
                  tumorBoardSlideId={group.tumorBoardSlideId}
                />
              )}
            </div>
          ) : (
            <div
              className="add-quorum-button"
              onClick={group.admin ? toggleModal : () => { }}
              style={group.admin ? null : styles.disabledButton}
              data-tooltip-content={
                group.admin
                  ? null
                  : "This function is available only to group admins"
              }
              data-tooltip-id="group-admin-tooltip"
            >
              <img src={PlusSrc} className="button-plus-img" alt="plus" />

              <h4 className="button-text">Add from SlideBox</h4>
            </div>
          )}

          {openSlidebox ? (
            <div
              className="overlay-quorum"
              id="quorum-modal-overlay"
              onClick={toggleModal}
            >
              <div
                className="modal-slidebox"
                onContextMenu={() => false}
              >
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 0.3 }}
                >
                  <div
                    className="header-modal"
                    style={{
                      paddingTop: 20,
                      paddingBottom: "25px",
                    }}
                  >
                    <div>
                      <img
                        src={AddFromSlideIcon}
                        alt="addSlide"
                        style={{ marginRight: 10 }}
                      />

                      <span
                        className="prompt-title"
                        style={{ fontSize: "16px" }}
                      >
                        Add from Slidebox
                      </span>
                    </div>

                    <img
                      className="close-icon"
                      src={ClosePopupIcon}
                      onClick={() => toggleModal("CLOSE MODAL")}
                      id="close_modal_streams"
                      style={{ cursor: "pointer" }}
                      alt="close"
                    />
                  </div>

                  <div
                    className="modal_middle"
                    onContextMenu={() => false}
                  >
                    <SlideboxPage
                      closeModal={toggleModal}
                      groupId={group.id}
                      isModal={isModal}
                      setOpenSlidebox={setOpenSlidebox}
                      navigate={navigate}
                      isFolderSelected={isFolderSelected}
                      setIsFolderSelected={setIsFolderSelected}
                      isOpenedFromGroups={true}
                    />
                  </div>

                  <div className="modal_bottom">
                    {isModal && (
                      <button
                        disabled={isFolderSelected}
                        className={
                          isFolderSelected
                            ? "next_btn deactive"
                            : "next_btn active"
                        }
                        onClick={handleOnNext}
                      >
                        NEXT
                      </button>
                    )}
                  </div>
                </motion.div>
              </div>
            </div>
          ) : null}
        </div>

        <Tooltip id="group-admin-tooltip" />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  imageFromSlideBox: state.SlideBox.quorumImageFromSlideBox || "",
  selectedListSlideData: state.SlideBox.selectedListSlideData,
  groups: state.Groups,
});

const mapDispatchToProps = (dispatch) => ({
  setSlideUrl: (payload) => dispatch(setSlideUrl(payload)),
  setSelectedBoard: (payload) => dispatch(setSelectedBoard(payload)),
  addTumorBoardEnable: (payload) =>
    dispatch(addTumorBoardEnable(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ImagePanel);